import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

export class CustomHttpLoader extends TranslateLoader {
  constructor(private http: HttpClient) {
    super();
  }

  getTranslation(lang: string, prefix: string = 'assets/i18n/'): any {
    return this.http.get(`${prefix}${lang}.json`, {withCredentials: false});
  }
}
export function createTranslateLoader(http: HttpClient) {
  return new CustomHttpLoader(http);
}


// WEBPACK FOOTER //
// ./src/app/utils/translate-module.ts